import cacheStatusActions, { cacheStatusTypes } from '../actions/CacheStatusActions';

const defaultInProgressState = { status: cacheStatusTypes.IN_PROGRESS, numberOfFailedItems: 0 };

export function setItemFailed(state, identifier) {
    const itemStatus = state[identifier]
        ? { ...state[identifier] }
        : defaultInProgressState;
    itemStatus.numberOfFailedItems++;

    return { ...state, [identifier]: itemStatus };
}

export function setStatus(state, action) {
    const { identifier, status, result } = action;

    const itemStatus = state[identifier] ? { ...state[identifier] } : {};

    itemStatus.status = status;
    itemStatus.result = result;

    return { ...state, [identifier]: itemStatus };
}

export function setLoadProgress(state, action) {
    const { identifier, totalLoaded, combinedSize, lastUpdatedTime, startTime, hasFailed } = action;
    const itemStatus = state[identifier]
        ? { ...state[identifier] }
        : defaultInProgressState;

    const previousLoadProgress = itemStatus.loadProgress;
    const percentageLoaded = Math.round((totalLoaded / combinedSize) * 100);
    const lastReferencePoint = previousLoadProgress?.lastUpdatedTime || startTime;
    const loadedSinceLastReferencePoint = totalLoaded - (previousLoadProgress?.totalLoaded || 0);
    const elapsedTimeSeconds = (lastUpdatedTime - lastReferencePoint) / 1000;

    const currentLoadSpeedBytes = Math.round(loadedSinceLastReferencePoint / 1000 / elapsedTimeSeconds);
    const estimatedTimeLeft = Math.round((combinedSize - totalLoaded) / 1000 / currentLoadSpeedBytes);

    itemStatus.loadProgress = {
        totalLoaded,
        combinedSize,
        percentageLoaded,
        currentLoadSpeedKbps: currentLoadSpeedBytes * 8,
        estimatedTimeLeft,
        lastUpdatedTime,
        startTime,
        hasFailed,
    };

    return { ...state, [identifier]: itemStatus };
}

export default function (state = {}, action) {
    switch (action.type) {
    case cacheStatusActions.types.CACHE_STATUS_SET:
        return setStatus(state, action);
    case cacheStatusActions.types.CACHE_STATUS_ITEM_FAILED:
        return setItemFailed(state, action.identifier);
    case cacheStatusActions.types.CACHE_LOAD_PROGRESS_SET:
        return setLoadProgress(state, action);
    default:
        return state;
    }
}
